import theme from './theme'

const config = {
  theme,
}

export default config
